import type {StackScreenProps} from '@react-navigation/stack';
import React from 'react';
import * as ReportUtils from '@libs/ReportUtils';
import type {ReportDescriptionNavigatorParamList} from '@navigation/types';
import type SCREENS from '@src/SCREENS';
import type {WithReportOrNotFoundProps} from './home/report/withReportOrNotFound';
import withReportOrNotFound from './home/report/withReportOrNotFound';
import RoomDescriptionPage from './RoomDescriptionPage';
import TaskDescriptionPage from './tasks/TaskDescriptionPage';

type ReportDescriptionPageProps = WithReportOrNotFoundProps & StackScreenProps<ReportDescriptionNavigatorParamList, typeof SCREENS.REPORT_DESCRIPTION_ROOT>;

function ReportDescriptionPage(props: ReportDescriptionPageProps) {
    const isTask = ReportUtils.isTaskReport(props.report);

    if (isTask) {
        // eslint-disable-next-line react/jsx-props-no-spreading
        return <TaskDescriptionPage {...props} />;
    }

    // eslint-disable-next-line react/jsx-props-no-spreading
    return <RoomDescriptionPage {...props} />;
}

ReportDescriptionPage.displayName = 'ReportDescriptionPage';

export default withReportOrNotFound()(ReportDescriptionPage);
